import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import _get from 'lodash/get';
import { HttpService } from '@app-core/services/http/http.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  API_URL = `${environment.API_DOMAIN}/${environment.API_PATH_PREFIX}`;

  constructor(private httpService: HttpService) {}

  public getDocumentTypes(): Observable<any> {
    const path = `${this.API_URL}/general/identitydocumenttype/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getGenders(): Observable<any> {
    const path = `${this.API_URL}/general/gender/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getMaritalStatuses(): Observable<any> {
    const path = `${this.API_URL}/general/maritalstatus/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getSoftwaresSelected(profile, soft): Observable<any> {
    const path = `${this.API_URL}/employee/software_&_systems/`;
    const params = new HttpParams()
      .set('profile', profile)
      .set('software_and_system', soft);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.post<any>(path, { params, headers });
  }

  public getEnglishLevels(): Observable<any> {
    const path = `${this.API_URL}/general/englishlevel/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getRequisitionCities(): Observable<any> {
    const path = `${this.API_URL}/general/city/`;
    const params = new HttpParams().set('requisition', 'True');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getVisaTypes(): Observable<any> {
    const path = `${this.API_URL}/general/visatype/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getTemporalCompanies(): Observable<any> {
    const path = `${this.API_URL}/general/temporalcompany/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getCities(params): Observable<any> {
    const path = `${this.API_URL}/general/city/`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getBranchCities(): Observable<any> {
    const path = `${this.API_URL}/general/city/`;
    const params = new HttpParams().set('requisition', 'true');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getStates(params): Observable<any> {
    const path = `${this.API_URL}/general/state/`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getCountries(): Observable<any> {
    const path = `${this.API_URL}/general/country/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }
  public getStatus(): Observable<any> {
    const path = `${this.API_URL}/general/Status/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }
  public getBranch(id): Observable<any> {
    const path = `${this.API_URL}/general/city/`;
    const params = new HttpParams().set('profile', id);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }
  public getAvailabilityLevels(): Observable<any> {
    const path = `${this.API_URL}/general/availability/`;
    const params = new HttpParams().set('active', 'True');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getSoftwares(id): Observable<any> {
    const path = `${this.API_URL}/general/software_&_systems/`;
    const params = new HttpParams().set('customer', id);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getInterest(): Observable<any> {
    const path = `${this.API_URL}/general/interestandhobby/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getLanguages(id): Observable<any> {
    const path = `${this.API_URL}/general/language/`;
    const params = new HttpParams()
      .set('page_size', '10000')
      .set('customer', id);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getUserInformation(id) {
    const path = `${this.API_URL}/user/user/${id}/`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { headers });
  }

  public changePassword(params) {
    const path = `${this.API_URL}/user/user/set_password/`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.put<any>(path, params, { headers });
  }

  public changeUserInformation(id, params) {
    const path = `${this.API_URL}/user/user/${id}/`;
    return this.httpService.put<any>(path, params);
  }

  public getEducationLevels() {
    const path = `${this.API_URL}/general/educationlevel/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'content-type': 'multipart/form-data',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getTemplates() {
    const path = `${this.API_URL}/general/template/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public updateTemplate(id, params) {
    const path = `${this.API_URL}/general/template/${id}/`;
    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });
    return this.httpService.put<any>(path, params, { headers });
  }

  public getAttachments(id) {
    const path = `${this.API_URL}/general/attachments/`;
    const params = new HttpParams().set('template', id);
    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getCourseStatus(): Observable<any> {
    const path = `${this.API_URL}/general/course_status/list/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getReferralsBranch() {
    const path = `${this.API_URL}/general/city/branches`;
    return this.httpService.get(path).pipe(
      map((response: any) => {
        return response.map((data) => {
          return {
            id: _get(data, 'id', null),
            name: _get(data, 'name', null),
          };
        });
      })
    );
  }

  public getReferredStatus() {
    const path = `${this.API_URL}/general/Status/referred`;
    return this.httpService.get<any>(path);
  }

  public updateAttachments(id, params) {
    const path = `${this.API_URL}/general/attachments/${id}/`;
    return this.httpService.put<any>(path, params);
  }

  public createAttachments(params) {
    const path = `${this.API_URL}/general/attachments/`;
    return this.httpService.post<any>(path, params);
  }

  public createDocument(params, id) {
    const path = `${this.API_URL}/recruitment/candidate/${id}/update_supervision_file/`;
    return this.httpService.put<any>(path, params);
  }

  public deleteAttachments(id) {
    const path = `${this.API_URL}/general/attachments/${id}/`;
    return this.httpService.delete<any>(path);
  }

  public getSkill(): Observable<any> {
    const path = `${this.API_URL}/general/skill/`;
    const params = new HttpParams().set('page_size', '10000');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public createSkill(params) {
    const path = `${this.API_URL}/general/skill/`;
    return this.httpService.post<any>(path, params);
  }

  public editkill(params, id) {
    const path = `${this.API_URL}/general/skill/${id}/`;
    return this.httpService.put<any>(path, params);
  }

  public deleteSkill(id) {
    const path = `${this.API_URL}/general/skill/${id}`;
    return this.httpService.delete<any>(path);
  }
}
